export default __webpack_public_path__ + "static/media/virtualpad_bt_b.a9f923ef.png";